// Views (and the inline blocks rendered through `yield :javascripts`) expect
// jQuery on the global object, as they did under the Sprockets pipeline.
// Imported before bootstrap so the global is in place first.
import jQuery from 'jquery'

window.jQuery = jQuery
window.$ = jQuery

export default jQuery
